import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Spinner from "react-bootstrap/Spinner";
import { AuthProvider } from "./context/FirebaseAuthContext";

// page imports
const LoginView = lazy(() => import("./views/LoginView"));
const RegisterView = lazy(() => import("./views/RegisterView"));
const HomepageView = lazy(() => import("./views/HomepageView"));
const CheckoutView = lazy(() => import("./views/CheckoutView"));
const Header = lazy(() => import("./views/components/Header"));
const Footer = lazy(() => import("./views/components/Footer"));

// Create a react query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000 * 120,
    },
  },
});

/**
 * e-Commerce app with authentication and transaction functionality.
 */
const App = () => {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Routes>
            {/* show homepage */}
            <Route path="/">
              <Route
                index
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <HomepageView isShopping={true} />
                    <Footer />
                  </Suspense>
                }
              />
              {/* only show login view if user is not signed in */}
              <Route
                path="/login"
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <LoginView />
                    <Footer />
                  </Suspense>
                }
              />
              {/* only show register view if user is not signed in */}
              <Route
                path="/register"
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <RegisterView />
                    <Footer />
                  </Suspense>
                }
              />
              {/* show homepage */}
              <Route
                path="/home"
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <HomepageView isShopping={true} />
                    <Footer />
                  </Suspense>
                }
              />
              {/* show user's cart page if signed in */}
              <Route
                path="/cart"
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <HomepageView isShopping={false} />
                    <Footer />
                  </Suspense>
                }
              />
              {/* only show checkout page if correct header is provided */}
              <Route
                path="/checkout"
                element={
                  <Suspense fallback={<Loading />}>
                    <Header />
                    <CheckoutView />
                    <Footer />
                  </Suspense>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
};

// display while page is still loading
const Loading = () => {
  return (
    <div className="App">
      <Spinner animation="border" />
    </div>
  );
};

export default App;
